import { render, staticRenderFns } from "./DialogPageChats.vue?vue&type=template&id=d24d4b88"
import script from "./DialogPageChats.vue?vue&type=script&lang=js"
export * from "./DialogPageChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports